// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useSubscription } from 'Data/Api'
import useDataConfiguration from './useDataConfiguration'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function MessageStatusUpdateData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, error }, reExecuteQuery] = useSubscription({ query, ...configuration })
  let data = rdata?.comms_events_sms_by_pk

      useSetFlowToBasedOnData({
        data,
        fetching: typeof data === 'undefined',
        error,
        pause: configuration.pause,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="sms_status"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}